import { z } from 'zod';

export const costPerVisitResponse = z.object({
  data: z.object({
    cost_per_visit: z.number().nullable(),
  }),
});

export const returnOnAdSpendResponse = z.object({
  data: z.object({
    return_on_ad_spend: z.number().nullable(),
  }),
});

export type CostPerVisitResponse = z.infer<typeof costPerVisitResponse>;
export type ReturnOnAdSpendResponse = z.infer<typeof returnOnAdSpendResponse>;
